module.exports = __webpack_public_path__ + "img/ep5-1.29fbbd39.png";